import _ from "lodash";

export function calculatePallets(packingType, boxes, brutto) {
  switch (packingType) {
    case "TransitBox":
      return boxes ? (brutto / 560).toFixed(2) : null; //TODO change weight base on country origin ?
    case "FlowerBox":
      return boxes ? (boxes / 21).toFixed(2) : null;
    case "PlantBox":
      return boxes ? (boxes / 21).toFixed(2) : null;
    case "GerberaBox":
      return boxes ? (boxes / 48).toFixed(2) : null;
    case "GreensBox":
      return boxes ? (boxes / 40).toFixed(2) : null;
    case "CCKar":
      return boxes ? (boxes * 0.65).toFixed(2) : null;
    case "KooiKar":
      return boxes ? (boxes * 1.2).toFixed(2) : null;
    case "Pallet":
      return boxes ? boxes.toFixed(2) : null;
    default:
      return 0;
  }
}

export function flatten(object, separator = ".") {
  const isValidObject = value => {
    if (!value) {
      return false;
    }

    const isArray = Array.isArray(value);
    const isObject =
      Object.prototype.toString.call(value) === "[object Object]";
    const hasKeys = !!Object.keys(value).length;

    return !isArray && isObject && hasKeys;
  };

  const walker = (child, path = []) => {
    return Object.assign(
      {},
      ...Object.keys(child).map(
        key =>
          isValidObject(child[key])
            ? walker(child[key], path.concat([key]))
            : { [path.concat([key]).join(separator)]: child[key] }
      )
    );
  };

  return Object.assign({}, walker(object));
}

export function getInitials(string) {
  let names = string.split(" "),
    initials = names[0].substring(0, 1).toUpperCase();
  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
}

export function injectPallets(data) {
  let result = _.map(data, order => {
    let amount = calculatePallets(
      order.packingTypeByPackingId && order.packingTypeByPackingId.type,
      order.boxes,
      order.brutto
    );
    return Object.assign({}, order, {
      amountPallets: Number(amount)
    });
  });
  return result;
}

export function _onColumnClick(event, column) {
  let { items, columns } = this.state;
  let isSortedDescending = column.isSortedDescending;
  if (column.isSorted) {
    isSortedDescending = !isSortedDescending;
  }
  if (isSortedDescending) {
    items = _.sortBy(items, column.fieldName);
  } else {
    items = _.reverse(_.sortBy(items, column.fieldName));
  }
  this.setState({
    items: items,
    columns: columns.map(col => {
      col.isSorted = col.key === column.key;
      if (col.isSorted) {
        col.isSortedDescending = isSortedDescending;
      }
      return col;
    })
  });
}



// WEBPACK FOOTER //
// ./src/utils/index.js